import { useContext } from 'react'
import { ThreadViewContext } from './threadView'

export const useThreadView = () => useContext(ThreadViewContext)
